module.exports = __webpack_public_path__ + "static/img/thumb-02.15afd49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/thumb/thumb-02.png
// module id = EW6F
// module chunks = 150